import Fab from '@mui/material/Fab';
import { makeStyles } from '@mui/styles';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';

const useStyles = makeStyles(theme => ({
  add: {
    position: "fixed",
    margin: 5,
    bottom: 4,
    right: 4
  },
  save: {
    position: "fixed",
    margin: 5,
    bottom: 4,
    right: 4
  },
  edit: {
    position: "fixed",
    margin: 5,
    bottom: 4,
    right: 4
  },
  delete: {
    position: "fixed",
    margin: 5,
    bottom: 4,
    right: 4
  }
}));

export const AddFab = (props) => {
  const classes = useStyles();

  return (
    <Fab
      className={classes.add}
      onClick={props.open}
      color="secondary"
    >
      <AddIcon />
    </Fab>
  );
}

export const DeleteFab = (props) => {
  const classes = useStyles();

  return (
    <Fab
      className={classes.delete}
      onClick={() => props.setOpen(true)}
      color="primary"
    >
      <DeleteIcon />
    </Fab>
  );
}

export const SaveFab = (props) => {
  const classes = useStyles();

  return (
    <Fab
      className={classes.save}
      onClick={() => props.setOpen(true)}
      color="secondary"
    >
      <SaveIcon />
    </Fab>
  );
}

export const EditFab = (props) => {
  const classes = useStyles();

  return (
    <Fab
      className={classes.delete}
      onClick={() => props.setOpen(true)}
      color="secondary"
    >
      <EditIcon />
    </Fab>
  );
}